import { useRouter } from 'next/router'
import { useRef } from 'react'

export function useRouterRef() {
	const router = useRouter()
	const ref = useRef(router)
	ref.current = router
	return ref
}
